
import Vue from 'vue'

import CustomTextModal from './CustomTextModal.vue'
import { RButton } from '@/components/'

export default Vue.extend({
  name: 'ExpandingStudioPlanModal',
  components: {
    CustomTextModal,
    RButton,
  },
  props: {
    nextBilling: {
      type: String,
      required: true,
    },
    monthlyWorkstationPriceUsd: {
      type: String,
    },
    daysRemaining: {
      type: Number,
      required: true,
    },
    priceForAdditionalWorkstation: {
      type: String,
    },
    pending: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    workstationPrice(): number {
      return parseFloat(this.monthlyWorkstationPriceUsd)
    },
  },
})
